import React from 'react'
import {
    SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarMenu,
    SidebarLink,
    SidebarBtnWrap,
    SidebarRoute,

} from './SideBarElements'

const Sidebar = ({ toggle, isOpen }) => {
    return (
        <>
            <SidebarContainer isOpen={isOpen} onClick={toggle}>
                <Icon onClick={toggle}>
                    <CloseIcon />
                </Icon>
                <SidebarWrapper>
                    <SidebarMenu>
                        <SidebarLink to="about" onClick={toggle}>
                            About
                        </SidebarLink>
                        <SidebarLink to="discover" onClick={toggle}>
                            Discover
                        </SidebarLink>
                        <SidebarLink to="services" onClick={toggle}>
                            Services
                        </SidebarLink>
                        <SidebarLink to="contactUs" onClick={toggle}>
                            Contact Us
                        </SidebarLink>
                    </SidebarMenu>
                    {/* <SidebarBtnWrap>
                        <SidebarRoute to="/">Sign In</SidebarRoute>
                    </SidebarBtnWrap> */}
                </SidebarWrapper>
            </SidebarContainer>
        </>
    )
}

export default Sidebar
